import React, { Component } from 'react'
import classNames from 'classnames'
import './Info.css'

const iconstr = `<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <path id="a" d="M11.5 23C17.85 23 23 17.85 23 11.5S17.85 0 11.5 0 0 5.15 0 11.5 5.15 23 11.5 23z"/>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <g>
      <use fill="#FFF" xlink:href="#a"/>
      <path class="circle" stroke="#417505" stroke-width="1.4" d="M11.5 22.3c5.965 0 10.8-4.835 10.8-10.8C22.3 5.535 17.465.7 11.5.7 5.535.7.7 5.535.7 11.5c0 5.965 4.835 10.8 10.8 10.8z"/>
    </g>
    <path class="icon" fill="#417505" d="M12.635 17.95H11V8.967h1.635v8.98zm0-11.282H11V5h1.635v1.668z"/>
  </g>
</svg>
`

function toggleState(state){
    return {
        open: !state.open
    }
}

class Info extends Component{
    state = {
        open: false
    }
    
    componentDidMount(){
        window.addEventListener('click', this.close)
    }
    
    componentWillUnmount(){
        window.removeEventListener('click', this.close)        
    }

    close = (event) => {
        if (event.target === this.button || event.target === this.content){
            return
        }
        
        this.setState({
            open: false
        })
    }

    toggleOpen = (event) => {
        event.preventDefault()
        this.setState(toggleState)
    }
    
    render(){
        const { children, className } = this.props
        const { open } = this.state
        return(
            [
                <div ref={el => this.content = el} key="info" className={classNames('info', {'info__open': open}, className)}>
                    <div aria-hidden={!open} role="alert" className={classNames('info--content', { 'info--content__open': open })}>
                        <div className="info--inner">
                            {children}
                        </div>
                    </div>
                </div>,
                <button key="button" ref={el => this.button = el} onClick={(event) => this.toggleOpen(event)} className="info--icon" dangerouslySetInnerHTML={{__html: iconstr}} />
            ]
        )
    }
}

export default Info


// WEBPACK FOOTER //
// ./src/components/Info/Info.js